/**
 * Zentrale App-Versionsnummer.
 *
 * Einzige Quelle der Wahrheit für die im UI angezeigte Version (Footer,
 * Support > Version-Panel). Bei jedem Release hier UND in package.json
 * ("version") synchron aktualisieren - die beiden Werte werden bewusst
 * nicht automatisch voneinander abgeleitet, damit die UI-Version auch ohne
 * Rebuild-Abhängigkeit von package.json einsehbar bleibt.
 */
export const APP_VERSION = '0.9.18';
